import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrderDetail as getOrderDetailApi } from "../../../helpers/backend_helper";

export const getOrderDetail = createAsyncThunk(
    "Order/getDetail",
    async (orderId: string | number) => {
        try {
            const response = await getOrderDetailApi(orderId);
            return response;
        } catch (error: any) {
            throw error;
        }
    },
);
